import React, { useState } from "react";
import { Card, Grid, Icon, InputText, Link, Picture, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import lists from "~/lib/lists";
import styled, { useTheme } from "styled-components";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryIssuesCard = _ref => {
  let {
    issues,
    initialLimit = 3,
    ...rest
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  let tempIssues = issues;
  if (!tempIssues.length) {
    return null;
  }
  const exceededLimit = tempIssues.length > initialLimit;
  const exceededLimitBy = limit && tempIssues.length > limit ? tempIssues.length - limit : undefined;
  if (exceededLimitBy) {
    tempIssues = tempIssues.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const filteredIssues = tempIssues.filter(_ref2 => {
    let {
      name,
      key,
      status
    } = _ref2;
    return query === "" || `${key}: ${name} ${status}`.toLowerCase().includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredIssues.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4,
    template: "1.7rem 1fr"
  }, filteredIssues.map(issue => /*#__PURE__*/React.createElement(React.Fragment, {
    key: issue.id
  }, /*#__PURE__*/React.createElement(Picture, {
    border: "squared",
    src: lists.common.apps.logos(theme)[issue.type],
    width: "1.7rem",
    height: "1.7rem",
    s: {
      mt: 2
    },
    backgroundSize: "contain"
  }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Link, {
    href: issue.url,
    color: theme.colors.text.primary,
    display: "block",
    fontSize: 4,
    weight: "semiBold"
  }, issue.key, ": ", issue.name, " "), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, issue.status, " \xB7 ", t("TopicSummaryCard.footprints", {
    count: issue.footprintCount
  })))))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No Issues"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: theme.colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryIssuesCard;